import { Phone, Mail, User } from 'lucide-react';

interface ContactCardProps {
  name: string;
  phone?: string;
  email?: string;
  avatarUrl?: string;
  role?: string;
}

export function ContactCard({ 
  name, 
  phone, 
  email, 
  avatarUrl,
  role 
}: ContactCardProps) {
  return (
    <div className="rounded-xl border bg-white p-4 shadow-sm transition-all hover:shadow-md">
      <div className="flex items-start gap-4">
        {/* Avatar */}
        <div
          className="flex h-12 w-12 flex-shrink-0 items-center justify-center overflow-hidden rounded-full"
          style={{ backgroundColor: '#f0e8ff' }}
        >
          {avatarUrl ? (
            <img 
              src={avatarUrl} 
              alt={name}
              className="h-full w-full object-cover"
            />
          ) : (
            <User className="h-6 w-6" style={{ color: '#3b0b86' }} />
          )}
        </div>

        {/* Contact Info */}
        <div className="flex-1 min-w-0">
          <h3 
            className="mb-0.5 font-semibold truncate" 
            style={{ fontFamily: 'var(--font-primary)', color: '#3b0b86' }}
          >
            {name}
          </h3>
          
          {role && (
            <p 
              className="mb-2 text-xs text-muted-foreground truncate"
              style={{ fontFamily: 'var(--font-secondary)' }}
            >
              {role}
            </p>
          )}

          <div className="space-y-1.5">
            {phone && (
              <a
                href={`tel:${phone}`}
                className="flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
                style={{ fontFamily: 'var(--font-secondary)' }}
              >
                <Phone className="h-4 w-4 flex-shrink-0" style={{ color: '#3b0b86' }} />
                <span className="truncate">{phone}</span>
              </a>
            )}
            
            {email && (
              <a
                href={`mailto:${email}`}
                className="flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
                style={{ fontFamily: 'var(--font-secondary)' }}
              >
                <Mail className="h-4 w-4 flex-shrink-0" style={{ color: '#3b0b86' }} />
                <span className="truncate">{email}</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
